import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { 
  RelatorioRiscoGaiolaRequest,
  RelatorioRiscoGaiolaResponse
} from 'src/app/@shared/models/relatorio-risco-gaiola.model';

const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

const filtrosLista = (obj: RelatorioRiscoGaiolaRequest) => {
  const filtro = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filtro);
}

@Injectable({
  providedIn: 'root'
})
export class RelatorioRiscoGaiolaService {
  constructor(
    private http: HttpClient
  ) { }

  listarRelatorioRiscoGaiola(obj?: RelatorioRiscoGaiolaRequest): Observable<RelatorioRiscoGaiolaResponse[]> {
    return this.http.get<RelatorioRiscoGaiolaResponse[]>(
      `RelatorioRiscoGaiola/ListarRelatorioGaiola?${filtrosLista(obj)}`,
      httpOptions
    );
  };

  public exportarExcel(obj: RelatorioRiscoGaiolaRequest): Observable<any> {
    return this.http.get<any>(`RelatorioRiscoGaiola/ExportarExcel?${filtrosLista(obj)}`, httpOptions);
  };
}
